import { Directive, ElementRef, Input, OnChanges, OnInit, Optional, Renderer2, SimpleChanges } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { DataService } from 'src/app/services/data/data.service';
import { UtilService } from '../services';


@Directive({
  selector: '[disableButton]'
})
export class DisableButtonDirective {

  @Input() disableButton: boolean = false;
  @Input() appDisableTitle: string = 'Disabled';
  
  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    @Optional() private matButton: MatButton) {

  }

  ngOnChanges(changes: SimpleChanges): void {
    this.updateButtonState();
  }

  private updateButtonState(): void {
    if (!!this.matButton) {
      this.matButton.disabled = this.disableButton; 
    }

    const host = this.el.nativeElement;
    if (!!host) {
      if (this.disableButton) {
        this.renderer.setAttribute(host, 'title', this.appDisableTitle);
        this.renderer.setStyle(host, 'cursor', 'not-allowed');
      }
      else {
        this.renderer.removeAttribute(host, 'title');
        this.renderer.setStyle(host, 'cursor', 'pointer');
      }
    }
  }
}
